import { zh } from '../i18n';
import { EmptyState } from '../components/ui';
import { AppShell } from './AppShell';

export function NotFoundRoute(): JSX.Element {
  return (
    <AppShell>
      <EmptyState title={zh.app.notFoundTitle} body={zh.app.notFoundBody} />
    </AppShell>
  );
}
